let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("7iCpI")).then(() => parcelRequire('6QVCK'));